<template>
  <CardBase :headerBorder="false">
    <template #header>{{ $route.meta.title }}</template>
    <template #toolbar>
      <router-link
        v-if="userCan('create.product')"
        :to="{ name: 'ProductCreate' }"
        class="button button--primary poppins"
      >
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />New
        Product
      </router-link>
    </template>
    <template #content>
      <form class="form form-search" method="get" @submit.prevent="reloadTable">
        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Search</label>
            <input
              type="text"
              class="form__input"
              placeholder="Product Name / Master"
              v-model="formData.search"
            />
          </div>
          <div class="form-search__double">
            <label class="form__label">Asset</label>
            <multiselect
              v-model="formData.asset"
              :options="listAsset"
              :loading="listAssetLoading"
              :close-on-select="true"
              :hide-selected="false"
              track-by="id"
              label="name"
              :placeholder="formData.asset ? formData.asset.name : 'All Asset'"
              :deselectLabel="'Remove selection'"
              :selectLabel="'Select this option'"
              @input="
                formData.asset_id = formData.asset ? formData.asset.id : ''
              "
            >
              <template #noResult>No results found.</template>
            </multiselect>
          </div>
        </div>

        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Category</label>
            <select class="form__input" v-model="formData.category_id">
              <option value="">Show All</option>
              <option
                v-for="row in listProductCategory"
                :key="row.id"
                :value="row.id"
              >
                {{ row.name }}
              </option>
            </select>
          </div>
          <div class="form-search__double">
            <label class="form__label">Group</label>
            <select class="form__input" v-model="formData.group_id">
              <option value="">Show All</option>
              <option
                v-for="row in listProductGroup"
                :key="row.id"
                :value="row.id"
              >
                {{ row.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-search__action">
          <div class="w-full flex">
            <BaseButton type="submit" buttonClass="secondary"
              >Search</BaseButton
            >
            <BaseButton
              class="mx-2"
              type="button"
              buttonClass="default"
              @click="reset"
              >Reset Search</BaseButton
            >
          </div>
        </div>
      </form>
      <vue-good-table
        :key="tableKey"
        mode="remote"
        theme="polar-bear"
        :rows="tableData.rows"
        :columns="tableData.columns"
        :total-rows="tableData.totalRows"
        :is-loading.sync="tableData.isLoading"
        :sort-options="{
          enabled: false,
        }"
        :pagination-options="{
          enabled: true,
          perPageDropdown: perPageDropdown,
          dropdownAllowAll: false,
          setCurrentPage: tableData.currentPage,
          infoFn: tablePageInfo,
        }"
        styleClass="vgt-table striped bordered"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'uuid'">
            <router-link
              :to="{ name: 'ProductEdit', params: { id: props.row.uuid } }"
              v-tooltip="'Edit ' + props.row.tooltip"
              class="table-action__link mx-2"
            >
              <font-awesome-icon :icon="['fas', 'edit']" />
            </router-link>
            <button
              class="table-action__link"
              v-tooltip="'Delete ' + props.row.tooltip"
              @click="deleteItem(props.row.uuid, props.row.tooltip)"
            >
              <font-awesome-icon :icon="['far', 'trash-alt']" />
            </button>
          </span>
        </template>
      </vue-good-table>

      <BasePaging
        v-if="!loading"
        class="mt-4"
        :path="'product'"
        :queryString="formData"
        :pagingData="pagingData"
      />
    </template>
  </CardBase>
</template>

<script>
import { showListMixin } from "@/mixins/showListMixin";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";
import { getListProductOptionsMixin } from "@/mixins/getListProductOptionsMixin";

export default {
  mixins: [showListMixin, getListAssetMixin, getListProductOptionsMixin],
  data: () => {
    return {
      tableData: {
        columns: [
          {
            label: "Asset",
            field: "asset.name",
          },
          {
            label: "Name",
            field: "name",
          },
          {
            label: "Master",
            field: "master",
          },
          {
            label: "Category",
            field: "category.name",
          },
          {
            label: "Group",
            field: "group.name",
          },
          {
            label: "",
            field: "uuid",
            thClass: "vgt-table__action",
            tdClass: "vgt-table__action",
          },
        ],
        sort_by: "master",
        sort_dir: "asc",
      },
      formData: {
        search: "",
        asset: null,
        asset_id: "",
        category_id: "",
        group_id: "",
      },
    };
  },
  created() {
    this.getListAsset();
    this.getListProductCategory();
    this.getListProductGroup();
  },
  watch: {
    $route() {
      const queryParams = this.$route.query;

      if (queryParams.asset_id != undefined) {
        this.listAsset.forEach((data) => {
          if (data.id == queryParams.asset_id) {
            this.formData.asset = data;
            this.formData.asset_id = data.id;
          }
        });
      }
    },
  },
  methods: {
    reset() {
      this.formData.search = "";
      this.formData.asset = null;
      this.formData.asset_id = "";
      this.formData.category_id = "";
      this.formData.group_id = "";

      this.tableData.limit = 10;

      if (this.$route.query.search == undefined) {
        this.tableKey++;
      } else {
        this.tableData.currentPage = 1;
        this.$router.push({ name: "ProductList" }).catch(() => {});
      }
    },
    reloadTable() {
      if (this.formData.search && this.formData.search.length < 3) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Search query must have at least 3 characters",
          icon: "warning",
        });
      } else {
        this.tableData.currentPage = 1;
        this.$router
          .replace({
            query: {
              search: this.formData.search,
              asset_id: this.formData.asset_id,
              category_id: this.formData.category_id,
              group_id: this.formData.group_id,
              tz: new Date().getTime(),
            },
          })
          .catch(() => {});
      }
    },
  },
};
</script>
